"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.GridContainer = void 0;
require("./GridContainer.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _modulesMap = require("../../util/recipeUtil/modulesMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * The GridContainer component is used to render components within the Pallete design systems grid system.  Users of the component are able to define hwere the content should start and end within the grid.
 *
 * @module views/components/GridContainer
 * @memberof -Common
 */

/**
 * Represents a GridContainer component
 *
this isrops} props - React properties passed from composition
 * @returns GridContainer
 */
const GridContainer = function (props) {
  const {
    backgroundColor,
    columns,
    children,
    fullBleed,
    id
  } = props;
  const hasColumns = columns && columns.length > 0;
  if (!hasColumns && !children) {
    return null;
  }
  const componentClassName = (0, _classnames.default)('pal-c-GridContainer', {
    [`pal-c-GridContainer__backgroundColor--${backgroundColor}`]: fullBleed && backgroundColor
  });
  const contentClassName = (0, _classnames.default)('pal-c-GridContainer__content', {
    [`pal-c-GridContainer__content__backgroundColor--${backgroundColor}`]: !fullBleed && backgroundColor
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: contentClassName
  }, hasColumns && columns.map((column, index) => /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('pal-c-GridContainer__column', {
      [`pal-c-GridContainer__column--startColumn${column.start}`]: column.start,
      [`pal-c-GridContainer__column--endColumn${column.end}`]: column.end,
      [`pal-c-GridContainer__column__backgroundColor--${column.backgroundColor}`]: column.backgroundColor,
      [`pal-c-GridContainer__column--align${column.align}`]: column.align
    }),
    key: `${id}-${index}`
  }, (0, _modulesMap.renderModules)(column))), !hasColumns && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children)));
};

/**
 * Property type definitions
 * @typedef GridContainerProps
 * @type {object}
 * @property {string} backgroundColor - sets the background color
 * @property {array} columns - array of columns
 * @property {array} children - node of children
 * @property {boolean} fullBleed - sets the width to full bleed if true
 * @property {string} id - component id
 */
exports.GridContainer = GridContainer;
const propTypes = exports.propTypes = {
  backgroundColor: _propTypes.default.string,
  columns: _propTypes.default.array,
  children: _propTypes.default.array,
  fullBleed: _propTypes.default.bool,
  id: _propTypes.default.string
};
GridContainer.propTypes = propTypes;
var _default = exports.default = GridContainer;